import { InfiniteScrollDataProps } from "ui/common/components/util/InfiniteDataList/InfiniteDataList.types";
import SimpleList from "ui/common/components/util/SimpleList/SimpleList";
import getFinalRenderListFunction from "ui/common/components/util/SimpleList/utils/getFinalRenderListFunction";
import { SplitInfiniteScrollPropsReturn } from "./splitInfiniteScrollProps.types";

export default function splitInfiniteScrollProps<E, P extends InfiniteScrollDataProps<E>>({
    //InfinitScroll props
    container,
    end = false,
    endElement,
    onEndReached,
    observerOffset,
    renderItem,
    children: childrenProp,
    data,
    //Data loader props
    isLoading = false,
    nothingToShow,
    numberOfSketelons,
    Skeleton,
    //Component props
    ...rest
}: P): SplitInfiniteScrollPropsReturn<E, P> {
    const pages = data?.pages || [];
    const hasItems = isLoading || pages.length > 0;
    //Get the render function, it can be a renderItem fn as prop or a children render fn
    const finalRenderItem = getFinalRenderListFunction({ children: childrenProp, renderItem });

    const children = (
        <>
            {finalRenderItem
                ? pages.map((page) => (
                      <SimpleList key={page.items.length} data={page.items} nothingToShow={nothingToShow} renderItem={finalRenderItem} />
                  ))
                : childrenProp}
            {/*Render skeletons and nothing to show */}
            {(isLoading || (!isLoading && pages.length === 0)) && (
                <SimpleList {...{ isLoading, numberOfSketelons, nothingToShow, Skeleton }} />
            )}
        </>
    );

    return {
        componentProps: rest,
        infiniteScrollProps: {
            container,
            endElement,
            children,
            end: !hasItems || end,
            loading: isLoading,
            callback: onEndReached,
            observerOffset,
        },
    };
}
